import type {
	CustomItem,
	DropAnchorType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropAnchor = (
	item: Item | CustomItem
): item is DropAnchorType => {
	return !!(item && item.__typename === 'Drop_Anchor');
};
